// extracted by mini-css-extract-plugin
module.exports = {"Select":"Select_Select__3GO5Q"};